export const relatedArticlesSlugsMap = {};
